<template>
  <!-- Side Map start -->
  <div>
    <div class="m-tour">
      <div class="cx-row--nogutter m-map__row">
        <div class="cx-col-wide" 
          :class="{fullscreendisable: isMapHide && showMapOnMobile}">
          <loading-view-placeholder class="sight-map-content">
            <router-view class="sight-map-content__inner"></router-view>
          </loading-view-placeholder>
        </div>
        <div class="cx-col-narrow" :style="mapDisplayStyle">
          <sight-map-map-container></sight-map-map-container>
        </div>
      </div>
    </div>
    <div v-show="showGeoFailAlert"
      class="cx-modal--full announcement-modal">
      <div class="cx-modal__body">
        <div class="cx-card--notify">
          <div class="cx-wrap--article">
            <div class="cx-div">
              <div class="cx-t20"
              >{{$t('geolocation.failHeader')}}</div>
            </div>
            <div class="cx-div" v-html="$t('geolocation.failContent')">
            </div>
            <div class="cx-div">
              <a class="cx-link "
                @click.prevent="$store.dispatch('geolocation/dismissFailAlert')">
                <span class="cx-link__icon"><i class="fal fa-times"></i></span>
                <span>{{$t('action.close')}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>  
    <div v-show="showGeoSupportAlert"
      class="cx-modal--full announcement-modal">
      <div class="cx-modal__body">
        <div class="cx-card--notify">
          <div class="cx-wrap--article">
            <div class="cx-div">
              <div class="cx-t20"
              >{{$t('geolocation.notSupportHeader')}}</div>
            </div>
            <div class="cx-div" v-html="$t('geolocation.notSupportContent')">
            </div>
            <div class="cx-div">
              <a class="cx-link "
                @click.prevent="$store.dispatch('geolocation/dismissSupportAlert')">
                <span class="cx-link__icon"><i class="fal fa-times"></i></span>
                <span>{{$t('action.close')}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>  
  <!-- Side Map end -->
</template>

<script>
import axios from 'axios';
import { mapState } from 'vuex';
import mapQueueHelper from '@/mixins/mapQueueHelper'
import LoadingViewPlaceholder from '@/components/LoadingViewPlaceholder';
import SightMapMapContainer from '@/components/SightMapMapContainer';

export default {
  name: 'sight-map-view',
  mixins: [ mapQueueHelper ],
  uit() {
    return [
      ['action', ['close']],
      ['geolocation', [
        'notSupportHeader',
        'notSupportContent',
        'failHeader',
        'failContent',
      ]]
    ]
  },
  data() {
    return {
      mounted: false,
    }
  },
  computed: {
    ...mapState({
      routing: state => state.ui.routing,
      isMapHide: state => state.ui.isMapHide,
      showMapOnMobile: state => state.ui.showMapOnMobile,
      showGeoSupportAlert: state => state.geolocation.showSupportAlert,
      showGeoFailAlert: state => state.geolocation.showFailAlert,
    }),
    mapDisplayStyle() {
      if (!this.isMapHide) {
        return {};
      } else {
        return {
          display: this.showMapOnMobile ? 'block' : 'none'
        };
      }
    }
  },
  components: {
    SightMapMapContainer,
    LoadingViewPlaceholder
  },
  mounted() {
    this.mounted = true;
  },
  updated: function () {
    this.$nextTick(() => {
      this.$InqueueMapEvent('updateMapClass')
    })
  },
  watch: {
    '$route.path': function() {
      let { path, name } = this.$route;
      path = path.split('/');
      let locale = path[1].toLowerCase();
      console.log('routing:', path, name, locale);
      if (!this.isValidLang(locale)) {
        return this.$router.replace({name: 'LanguageRouter'});
      }
      
      if (((path.length < 3) || (path.length == 3 && path[path.length - 1] == '')) && name != `Home_${locale}` ) {
        return this.$router.replace({
          name: `Home_${locale}`
        })
      }
    }
  }
}
</script>



<style lang="scss">
  #map-intro {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .m-poi-marker{
    cursor: grab !important;
  }
  .m-media__action--sticky{
    // css order
    z-index: 80 !important;
    height: 100%;
    top: 0px;
    padding-top: $space-base;
    pointer-events: none;
    a{
      position: sticky;
      top: $space-base;
      pointer-events: all;
    }
  }

  .m-map{
    &__wrap{
      // padding: 2rem 3rem;
      @media(max-width:767px){
        // padding: 2rem 1rem;
      }
    }
    &__list{
      margin-top: $space-lg;
      margin-bottom: $space-base;
      padding-bottom: 2rem;
      margin-right: -$space-base;
      margin-left: -$space-base;
    }
    &__item{
      color: $color-darkgrey;
    }
    &__title{
      font-size: $font-size-md;
    }
    &__desc{
      font-size: $font-size-base;
    }
    &__flex{
      margin-top: 10px;
    }
    &__flat{
      margin-bottom: 40px;
    }
    &__tour{
      padding-left: 1rem;
      padding-right: 1rem;
      &.small{
        @media(min-width:768px){
          .m-map__flat{
            display: flex;
            flex-wrap: nowrap;
            padding: 0 15px;
            margin-bottom: 15px;
          }
          .cx-row{
            flex-wrap: nowrap;
            margin: 0;
          }
          .cx-col{
            padding: 0;
            width: auto;
          }
          .m-map__flex{
            display: flex;
            align-items: center;
            margin-left: 15px;
            margin-top: 0;
          }
          // .m-mapitem__caption{
          //   display: none;
          // }
        }
      }
    }
  }
  .m-mapitem{
    color: $color-darkgrey;
    // margin-bottom: 2rem;
    margin-top: 1rem;
    display: block;
    &:hover{
      text-decoration: none;
      color: $color-darkgrey;
    }
    &__text{
      color: $color-black;
      margin-top: $int-space-xs;
    }
    &__flex{
      @include set-font(.7);
      display: flex;
      align-items: center;
    }
    &__article{
      .cx-div{
        margin-bottom: $space-lg;
      }
    }
    &__next{
      &:hover{
        text-decoration: none;
      }
      .m-mapitem__link{
        margin-right: 15px;
      }
    }
    &__mobilecard{
      @include set-font(.3);
      .cx-col{
        align-self: center;
      }
      .m-mapitem__title{
        color: $color-primary;
      }
      .m-mapitem__subtitle{
        line-height: 1.3;
      }
      .cx-media{
        width: 80px;
      }
    }
    &__routelist{
      margin: 2rem auto;
      .cx-media{
        &:after{
          content: "";
          position: absolute;
          width: 3px;
          margin-left: -1px;
          left: 50%;
          top: 100%;
          background-color: $color-border;
          height: 2em;
          display: block;
        }
        @media (max-width: $breakpoint-sm) {
          width: 80px;
        }
      }
      .m-mapitem__list:last-child{
        .cx-media:after{
          display: none;
        }
      }
    }
    &__list{
      color: $color-darkgrey;
      margin-bottom: 2em;
      &:hover{
        text-decoration: none;
      }
      &:first-child{
        .m-mapitem__before{
          &:before{
            display:none;
          }
        }
      }
    }
    &__thumb{
      z-index: 50;
      position: relative;
    }
    &__thumbicon{
      z-index: 60 !important;
    }
    &__colup{
      // margin-top: -3rem;
      @media(max-width:767px){
        // margin-top: 0;
        margin-top: -1rem;
      }
    }
    &__social{
      a{
        font-weight: normal;
      }
    }
    &__breadcrumb{
      padding-top: $space-sm !important;
      padding-bottom: $space-sm !important;
    }
    &__flat{
      margin:0;
    }
    &__meta{
      margin-bottom: 0;
      font-size: $font-xs;
      text-transform: uppercase;
      font-weight:700;
      div{
        display: inline-block;
        margin-right: 1em;
      }
    }
    &__title{
      font-size: $font-md;
      font-weight:700;
    }
    &__notice{
      background: rgba($color-green, .1);
      border-radius: .2em;
      padding: .2em .5em;
      color: $color-green;
    }
    &__relatedtitle{
      @media(max-width:991px){
        margin: 1rem 0;
      }
    }
    &__sectitle{
      font-size: $font-base;
      font-weight:700;
      line-height: $lineheight-base;
    }
    &__date{
      line-height: $lineheight-sm;
      margin-top: $int-space-base; 
      span:first-of-type{
        margin-right: $space-xs;
      }           
    }
    &__subtitle{
      // @extend %style-subtitle;
      @include normalize-link;
      font-weight:700;
      line-height: $lineheight-sm;
      margin-bottom: .2rem;
      display: inline-block;
      // span + span{
      //   margin-left: $space-sm;
      // }
      a{
        border-bottom: 1px solid $color-border;
        &:hover{
          border-bottom-color: rgba($color-primary, .3);
        }
      }
    }
    &__header{
      margin-bottom: 2rem;
    }
    &__caption{
      font-size: $font-sm;
      margin-bottom: 2rem;
    }
    &__nextcaption{
      color: $color-darkgrey;
      @media(max-width:767px){
        .m-mapitem__text{
          display:  none;
        }
      }
    }
    &__img{
      &--solid{
        background-color: $color-green;
      }
      &--marker{
        position: absolute;;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        i{
          color: $color-white;
          font-size: $font-lg;
        }
      }
    }
    &__allbtn{
      background-color: transparent;
      border: 0;
      align-items: center;
      cursor: pointer;
      &:hover{
        text-decoration: none;
        .m-mapitem__nextcaption{
          opacity: .8;
        }
      }
      .m-mapitem__nextcaption{
        font-weight: 700;
      }
      .cx-media:after{
          display: none;
        }
    }
  }
  #map-related{
    margin-top: auto;
  }
  #map-mobileshow{
    display: none;
    z-index: 500;
    position: relative;
    margin: 10px;
    margin-top: auto;
    padding: 10px 0px;
    background: white;
    border-radius: 5px;
    width: auto;
  }
  .fullscreendisable{
    position: absolute !important;
    bottom: 0; 
    .m-map__mobilecontent{
      display: block;
    }
    #map-intro, #map-related, #map-suggest{
      display: none;
    }
    #map-mobileshow{
      display: block;
    }
  }
</style>